import React from "react";
import WeaTextareaNormal from "../base/wea-textarea-normal";
import WeaTextareaLocale from "../base/wea-textarea-locale";
import WeaTools from "../wea-tools";
import middleware from "../../middleware";

class main extends React.Component {
  static defaultProps = {
    inputType: "NORMAl",
    className: "",
    style: {},
    overlayClassName: ""
  };
  static propTypes = {
    inputType: React.PropTypes.string
  };
  componentDidMount() {
    const isMulti = window.localStorage.getItem("activeLanguageIds");
    if (this.props.inputType.toUpperCase() === "MULTILANG") {
      if (isMulti === null) {
        WeaTools.callApi(
          "/api/system/language/base/getActiveLanguage",
          "GET"
        ).then(res => {
          if (res.activeLanguageIds)
            window.localStorage.setItem(
              "activeLanguageIds",
              JSON.stringify(res.activeLanguageIds)
            );
        });
      }
    }
  }
  setValue(v = "") {
    this.refs.textareaNormal && this.refs.textareaNormal.setValue(v);
  }
  focus = () => {
    this.form && this.form.focus && this.form.focus();
    this.multilang && this.multilang.focus && this.multilang.focus();
    this.refs.textareaNormal &&
      this.refs.textareaNormal.focus &&
      this.refs.textareaNormal.focus();
  };
  render() {
    const { children, ...resProps } = this.props;
    const { inputType } = resProps;
    let isMulti = window.localStorage.getItem("activeLanguageIds") || "[7]";
    try {
      isMulti = JSON.parse(isMulti);
    } catch (error) {
      isMulti = [];
      console.error("获取多语言配置信息失败", error);
    }
    if (inputType.toUpperCase() == "FORM") {
      return [
        <input
          ref={ref => (this.form = ref)}
          class={this.props.className}
          style={this.props.style}
        />,
        children
      ];
    }
    if (inputType.toUpperCase() === "MULTILANG" && isMulti.length > 1) {
      return [
        <WeaTextareaLocale ref={ref => (this.multilang = ref)} {...resProps} />,
        children
      ];
    }
    return [<WeaTextareaNormal ref="textareaNormal" {...resProps} />, children];
  }
}

const Com = middleware(main, "WeaTextarea");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-textarea/index.js